import { render } from "./UserCompanyBranchAccess.vue?vue&type=template&id=08905006"
import script from "./UserCompanyBranchAccess.vue?vue&type=script&lang=js"
export * from "./UserCompanyBranchAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__